var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#506D85",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463 1808 l452 -753 5 -378 5 -378 348 -150 c192 -82 353 -149 358 -149 5 0 9 214 9 523 l0 522 455 758 454 757 -1269 0 -1269 0 452 -752z m1769 560 c-11 -18 -185 -307 -386 -643 l-366 -610 0 -432 c0 -238 -1 -433 -3 -433 -1 0 -90 38 -197 84 l-195 83 -5 354 -5 354 -369 615 c-203 338 -376 625 -384 638 l-14 22 972 0 972 0 -20 -32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutline);
export default __webpack_public_path__ + "static/media/filter-outline.8846820fbf329476fd3422a785024ec5.svg";
export { ForwardRef as ReactComponent };